export type BaseDialogType<Return = boolean, Input = void> = {
  open: (input: Input) => Promise<Return | undefined>;
  cancel: (event?: Event) => void;
};

export enum DialogResolveStatus {
  ok = 'dialog-resolve-status-ok',
  stop = 'dialog-resolve-status-stop',
}

export type DialogProps = {
  isOpen?: boolean;
};

export type DialogEmits = {
  (e: 'update:is-open', v: boolean): void;
  (e: 'resolve', v?: unknown | undefined | void): void;
  (e: 'cancel' | 'click:outside' | 'close'): void;
};
